import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function SizePickerDialog({ product, open, onOpenChange }) {
  const [selected, setSelected] = useState(null);
  const { add } = useCart();

  useEffect(() => {
    if (open) setSelected(null);
  }, [open]);

  if (!product) return null;
  const sizes = product.sizes || ["S", "M", "L", "XL", "2XL", "3XL"];

  const confirm = () => {
    if (!selected) return;
    add(product, 1, selected);
    toast.success(`${product.name} (${selected}) added to cart`);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="size-picker-dialog" className="rounded-none border-2 border-halo-navy max-w-md">
        <DialogHeader>
          <DialogTitle className="font-sports uppercase tracking-tight text-2xl leading-tight">
            {product.name}
          </DialogTitle>
          <DialogDescription className="font-body text-sm text-halo-navy/60">
            Select your size · Black · ${product.price.toFixed(2)}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          <div className="grid grid-cols-3 gap-2">
            {sizes.map((s) => (
              <button
                key={s}
                type="button"
                data-testid={`size-${s}`}
                onClick={() => setSelected(s)}
                className={`aspect-square flex flex-col items-center justify-center border-2 font-sports uppercase tracking-tight transition-colors ${
                  selected === s
                    ? "bg-halo-red border-halo-red text-white"
                    : "border-halo-navy/30 text-halo-navy hover:border-halo-navy"
                }`}
              >
                <span className="text-2xl leading-none">{s}</span>
              </button>
            ))}
          </div>

          <button
            data-testid="add-with-size-btn"
            disabled={!selected}
            onClick={confirm}
            className="w-full flex items-center justify-center gap-2 bg-halo-navy hover:bg-halo-red disabled:opacity-40 disabled:cursor-not-allowed text-halo-cream font-sports uppercase tracking-wider py-4 text-sm transition-colors"
          >
            <ShoppingBag className="w-4 h-4" strokeWidth={2.5} />
            {selected ? `Add ${selected} to Cart` : "Choose a size"}
          </button>
          <p className="text-[11px] font-body text-halo-navy/50 text-center">
            All shirts printed on black tees. Unisex sizing.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
